// Els textos del mòdul, en català. Mateix joc de claus que es.js — vegeu-ne la capçalera.

export default {
  errors: {
    REPORT_SCHEDULE_OWNER_ONLY: 'Un informe programat s’executa amb els permisos de qui el va crear: només aquesta persona el pot canviar.',
  },
  // Como se llama este modulo en las pantallas de la plataforma (el
  // selector de la demo, Roles, Auditoria). Sin esto salen listando el
  // slug en ingles, que se lee como un modulo a medio hacer.
  modules: { reports: 'Informes' },

  reports: {
    assistant: {
      save: {
        action: 'Desar informe',
        field: { title: 'Nom', sections: 'Seccions', period: 'Període' },
        after: 'Es desen les preguntes: en obrir-lo es recalculen les xifres',
        outcome: 'Informe «{title}» desat',
      },
      schedule: {
        action: 'Enviar un informe amb calendari',
        summary: {
          daily: 'Enviar «{title}» cada dia a les {hour}:00',
          weekly: 'Enviar «{title}» cada setmana (dia {day}) a les {hour}:00',
          monthly: 'Enviar «{title}» cada mes, el dia {day}, a les {hour}:00',
          quarterly: 'Enviar «{title}» cada trimestre, el dia {day}, a les {hour}:00',
        },
        frequency: { daily: 'Cada dia', weekly: 'Cada setmana', monthly: 'Cada mes', quarterly: 'Cada trimestre' },
        field: {
          report: 'Informe',
          frequency: 'Cada quant',
          weekday: 'Dia de la setmana (1 = dilluns)',
          monthDay: 'Dia del mes',
          hour: 'Hora',
          recipients: 'Per a',
        },
        you: 'Tu',
        where: 'Informe',
        notSaved: 'No hi ha cap informe desat amb aquest nom: desa\'l primer i després programa\'l',
        asOwner: 'Es calcula amb els teus permisos cada vegada que surt',
        outcome: '«{title}» programat',
      },
    },
    title: 'Informes',
    subtitle: 'Les xifres de tota la casa, i què volen dir',
    guide: 'Cada pestanya és un mòdul instal·lat que sap mesurar alguna cosa. Les xifres les '
      + 'calcula aquell mòdul, amb els teus permisos: aquí no hi ha cap còpia de les seves dades.',

    period: 'Període',
    total: 'Total',

    nav: {
      saved: 'Desats',
      explore: 'Explorar',
    },

    kind: {
      report: 'Informe',
      board: 'Tauler',
    },

    tabs: {
      all: 'Tota l\'empresa',
    },

    empty: {
      title: 'Encara no hi ha res a mesurar',
      hint: 'Els informes surten dels mòduls instal·lats. Instal·la\'n un —facturació, obres, '
        + 'compres— i la seva pestanya apareix sola.',
    },

    actions: {
      save: 'Desar',
      cancel: 'Cancel·lar',
      edit: 'Editar',
      done: 'Fet',
      remove: 'Treure',
    },

    fields: {
      title: 'Nom',
      description: 'Descripció',
      modules: 'D\'on surten les xifres',
      visibility: 'Qui el veu',
      lastRun: 'Vist per última vegada',
    },

    severity: {
      critical: 'Greu',
      warning: 'Avís',
      info: 'Info',
      good: 'Bona notícia',
    },

    summary: {
      title: 'Lectura de les xifres',
      subtitle: 'Escrita sobre els números de sota, i només sobre ells',
      generate: 'Llegir les xifres',
      again: 'Tornar-les a llegir',
      working: 'Llegint les xifres…',
      idleTitle: 'Encara sense lectura',
      idleHint: 'Costa uns segons i consumeix pressupost d\'IA, així que es demana.',
      quiet: 'Res destacable en aquest període.',
      caveat: 'És una lectura de les xifres que tens a sota, no una xifra més. Els números són '
        + 'l\'informe; això és una opinió sobre ells.',
      evidence: 'En què es basa',
      impact: 'Quant hi ha en joc',
      cause: 'Possible causa',
      action: 'Què fer',
      confidence: {
        high: 'confiança alta',
        medium: 'confiança mitjana',
        low: 'confiança baixa',
      },
      unavailable: {
        DISABLED: 'La lectura automàtica està apagada als ajustos del mòdul.',
        NO_DATA: 'No hi ha prou xifres en aquest període per dir res.',
        UNREADABLE: 'La resposta no s\'ha pogut llegir. Torna-ho a provar.',
        AI_PROVIDER_ERROR: 'El proveïdor d\'IA no ha respost. Les xifres de sota estan bé.',
        generic: 'La lectura no està disponible ara mateix.',
      },
    },

    kpis: {
      title: 'Les xifres',
      subtitleAll: 'El que cada mòdul instal·lat posa al davant',
      subtitleModule: 'El que {module} posa al davant',
      empty: 'Cap mòdul ha tornat xifres per a aquest període',
      failed: 'No s\'han pogut llegir les xifres de: {modules}',
    },

    changes: {
      title: 'Què ha canviat',
      subtitle: 'Ordenat pel que hi ha en joc, no pel percentatge',
      emptyTitle: 'Res s\'ha mogut prou',
      emptyHint: 'El llindar es toca a la configuració del mòdul.',
    },

    insights: {
      title: 'Què hauries de saber',
      subtitle: 'El que els mòduls han aixecat sense que ningú preguntés',
      emptyTitle: 'Res a explicar',
      emptyHint: 'És una bona notícia: res ha creuat les línies que vas posar.',
      why: 'Per què?',
      acknowledge: 'Ja ho sé',
    },

    focus: {
      subtitle: 'La mateixa xifra, mes a mes. Prem una fila per baixar un nivell.',
      open: 'Obrir a Explorar',
      close: 'Tancar',
    },

    chart: {
      empty: 'Sense dades per dibuixar',
    },

    widget: {
      noRows: 'Sense files en aquest període',
      nothing: 'Sense calcular',
      failed: 'No s\'ha pogut calcular',
      truncated: 'Es mostren les primeres {shown} files. Els totals cobreixen tot.',
    },

    quality: {
      generic: 'Avís sobre les dades: {code}',
      NO_DATA: 'No hi ha dades en aquest període.',
      SHORT_HISTORY: 'Només hi ha {points} períodes d\'historial: és poc per parlar de tendència.',
      NOT_ENOUGH_FOR_FORECAST: 'Amb {points} períodes no es pot projectar res amb sentit.',
      MOSTLY_EMPTY: '{empty} de {points} períodes són buits.',
      INVOICES_WITHOUT_DUE_DATE: 'El {percent} % de les factures no té data de venciment, així '
        + 'que no poden sortir com a vençudes.',
      INVOICE_LINES_WITHOUT_COST: 'El {percent} % de les factures no porta cost a les línies: '
        + 'el marge surt millor del que és.',
      QUOTES_LOST_WITHOUT_REASON: 'El {percent} % dels pressupostos perduts no diu per què.',
      CUSTOMERS_WITHOUT_SECTOR: 'El {percent} % dels clients no té sector.',
      PROJECTS_WITHOUT_BUDGET: 'El {percent} % de les obres obertes no té cost pressupostat, '
        + 'així que no poden sortir com a desviades.',
      PROJECTS_WITHOUT_COST: 'El {percent} % de les obres obertes no té cap cost imputat.',
      ORDERS_WITHOUT_EXPECTED_DATE: 'El {percent} % de les comandes no té data prevista.',
      MATERIALS_WITHOUT_COST: 'El {percent} % del material amb existències no té cost: la '
        + 'valoració es queda curta.',
      ORDERS_WITHOUT_ESTIMATE: 'El {percent} % de les ordres acabades no tenia hores estimades.',
      REFUELS_WITHOUT_PRICE: 'El {percent} % dels proveïments no porta import.',
      ATTENDANCE_DAYS_LEFT_OPEN: '{count} jornades ({percent} %) es van quedar sense tancar: '
        + 'les seves hores es compten fins ara mateix.',
      ATTENDANCE_PERIOD_TOO_LARGE: 'El període té més de {limit} fitxatges i s\'ha tallat. '
        + 'Demana un període més curt.',
    },

    findings: {
      metric_moved: '«{metric}»: {percent} % respecte al període anterior.',
      module_insight: 'Un mòdul ha aixecat un avís.',
      invoices_overdue: '{count} factures estan vençudes, la més antiga per {days} dies '
        + '({amount} €).',
      customer_concentration: '{name} és el {percent} % del que s\'ha facturat al període.',
      customers_gone_quiet: '{count} clients actius fa mesos que no facturen. El més gran és '
        + '{name}, fa {months} mesos.',
      quotes_gone_quiet: '{count} pressupostos enviats fa més d\'un mes segueixen sense resposta '
        + '({amount} €).',
      projects_over_budget: '{count} obres obertes han passat del pressupost. {code} va un '
        + '{percent} % per sobre.',
      supplier_concentration: '{name} és el {percent} % del que s\'ha comprat al període.',
      supplier_delivering_late: '{name} lliura amb {days} dies de retard de mitjana, sobre '
        + '{orders} comandes.',
      stock_not_moving: '{count} materials fa un any que no es mouen, per valor de {amount} €.',
      product_over_estimate: '{name} triga un {percent} % més del que s\'havia estimat, en '
        + '{orders} ordres.',
      field_incident_rate: '{rate} incidències per cada 100 ordres de treball al període.',
      maintenance_overdue: '{count} de {total} plans de manteniment estan vençuts, el més antic '
        + 'per {days} dies.',
      asset_repeat_failures: '{name} ha fallat {count} vegades al període, amb {hours} hores '
        + 'd\'aturada.',
      absences_awaiting_approval: '{count} sol·licituds d\'absència esperen resposta, la més '
        + 'antiga des de fa {days} dies.',
      personnel_documents_expired: '{count} documents de personal estan caducats.',
      personnel_documents_expiring: '{count} documents de personal caduquen en un mes, de '
        + '{people} persones.',
      market_cost_exposure: '{name} s\'ha mogut un {percent} %: uns {amount} € l\'any '
        + '(confiança {confidence} %).',
      leads_unanswered: '{count} consultes del web segueixen sense contestar, la més antiga des '
        + 'de fa {days} dies.',
    },

    filters: {
      period: 'Període',
      from: 'Des de',
      to: 'Fins a',
      compare: 'Comparar amb',
    },

    periods: {
      this_month: 'Aquest mes',
      last_month: 'El mes passat',
      this_quarter: 'Aquest trimestre',
      last_quarter: 'El trimestre passat',
      this_year: 'Aquest any',
      last_year: 'L\'any passat',
      year_to_date: 'El que va d\'any',
      last_7_days: 'Últims 7 dies',
      last_30_days: 'Últims 30 dies',
      last_90_days: 'Últims 90 dies',
      last_6_months: 'Últims 6 mesos',
      last_12_months: 'Últims 12 mesos',
      all_time: 'Tot l\'històric',
      custom: 'Entre dues dates',
    },

    compare: {
      previous_period: 'El període anterior',
      previous_year: 'El mateix període de l\'any passat',
      none: 'Amb res',
    },

    visualisations: {
      kpi: 'Una xifra',
      line: 'Línia',
      area: 'Àrea',
      bar: 'Barres',
      stacked_bar: 'Barres apilades',
      pie: 'Pastís',
      donut: 'Anell',
      table: 'Taula',
    },

    operators: {
      eq: 'és',
      ne: 'no és',
      in: 'és un de',
      nin: 'no és cap de',
      gt: 'més gran que',
      gte: 'més gran o igual que',
      lt: 'més petit que',
      lte: 'més petit o igual que',
      contains: 'conté',
      between: 'entre',
      exists: 'té valor',
    },

    explore: {
      title: 'Explorar',
      subtitle: 'Una pregunta cada vegada, sobre el que tinguis instal·lat',
      guide: 'Tria un tema, les xifres que vols i per què agrupar-les. Només apareix el que pots '
        + 'veure: el que no és a les llistes, no és teu.',
      question: 'La pregunta',
      dataset: 'Sobre què',
      datasetHint: 'Cada mòdul instal·lat aporta els seus.',
      grain: 'Cada fila és: {grain}',
      metrics: 'Què mesurar',
      metricsHint: 'Sense triar-ne cap surten les que el mòdul posa al davant.',
      metricsPlaceholder: 'Escriu i prem Retorn',
      dimensions: 'Agrupat per',
      dimensionsHint: 'Com a molt tres. Per acotar més, fes servir un filtre.',
      dimensionsPlaceholder: 'Client, sector, comercial…',
      granularity: 'En el temps',
      noGranularity: 'Sense eix de temps',
      autoVisualisation: 'La que hi vagi bé',
      granularities: {
        auto: 'Automàtic',
        day: 'Per dia',
        week: 'Per setmana',
        month: 'Per mes',
        quarter: 'Per trimestre',
        year: 'Per any',
      },
      dateField: 'Quina data mana',
      dateFieldHint: 'Canvia què vol dir «al juliol».',
      visualisation: 'Com es dibuixa',
      limit: 'Quantes files',
      filters: 'Filtres',
      filtersHint: 'Els totals segueixen cobrint tot el que passi el filtre.',
      addFilter: 'Afegir filtre',
      removeFilter: 'Treure',
      value: 'Valor',
      run: 'Calcular',
      save: 'Desar com a informe',
      saveTitle: 'Desar la pregunta',
      saved: 'Desat',
      answerBy: '{metrics} per {dimension}',
      rowCount: '{count} files',
      reading: 'Quina forma té',
      readingHint: 'Tendència, valors estranys i projecció, cadascun amb com de segur és',
      readingIdle: 'Encara sense analitzar',
      analyse: 'Analitzar',
      trend: 'Tendència',
      trendUnclear: 'No es veu una tendència clara amb {points} períodes.',
      trends: {
        up: 'Puja un {percent} % per període (ajust del {fit} %).',
        down: 'Baixa un {percent} % per període (ajust del {fit} %).',
        flat: 'Plana.',
        unknown: 'Sense dades suficients.',
      },
      anomalies: 'Períodes estranys',
      forecast: 'Projecció',
      forecastNone: 'No hi ha prou historial per projectar res.',
      forecastNext: 'El pròxim període: {value} (entre {low} i {high}, {confidence}).',
      confidence: {
        high: 'confiança alta',
        medium: 'confiança mitjana',
        low: 'confiança baixa',
        insufficient: 'sense base',
      },
      caveats: 'Amb quin compte',
    },

    saved: {
      title: 'Informes desats',
      subtitle: 'Les preguntes que algú va voler tornar-se a fer',
      search: 'Cercar',
      searchPlaceholder: 'Per nom, descripció o etiqueta',
      module: 'De quin mòdul',
      allModules: 'De tots',
      empty: 'Encara no hi ha res desat',
      never: 'Mai',
      template: 'Plantilla',
      company: 'Tota l\'empresa',
      shared: 'Compartit',
      private: 'Només jo',
      scheduled: 'Programat',
      scopes: {
        all: 'Tots',
        mine: 'Meus',
        shared: 'Compartits amb mi',
        templates: 'Plantilles',
        scheduled: 'Programats',
      },
    },

    report: {
      loading: 'Obrint l\'informe…',
      periodHint: 'Canviar el període aquí no canvia l\'informe: és una mirada, no una decisió.',
      narrate: 'Escriure les conclusions',
      export: 'Exportar',
      schedule: 'Programar',
      saved: 'Desat',
      editing: 'Afegir a l\'informe',
      sectionTitle: 'Títol de la secció',
      addText: 'Un text',
      addNarrative: 'Conclusions d\'IA',
      addInsights: 'Els avisos',
      addQuery: 'Una pregunta nova',
      conclusions: 'Conclusions',
      conclusionsHint: 'Escrites sobre les xifres d\'aquesta secció',
      conclusionsIdle: 'Prem «Escriure les conclusions» a dalt',
      emptyTitle: 'L\'informe és buit',
      emptyHint: 'Afegeix una pregunta des d\'Explorar, o un text des d\'aquí.',
      formats: {
        pdf: 'PDF',
        docx: 'Word',
        csv: 'CSV',
      },
    },

    schedule: {
      title: 'Programar l\'informe',
      hint: 'Surt sol, a l\'hora que diguis, i arriba per correu a gent que pot no tenir compte '
        + 'aquí. Es calcula amb els TEUS permisos.',
      enabled: 'Enviar-lo sol',
      frequency: 'Cada quant',
      frequencies: {
        daily: 'Cada dia',
        weekly: 'Cada setmana',
        monthly: 'Cada mes',
        quarterly: 'Cada trimestre',
      },
      weekday: 'Quin dia de la setmana (1 = dilluns)',
      monthday: 'Quin dia del mes',
      hour: 'A quina hora (UTC)',
      recipients: 'A quines adreces',
      recipientsHint: 'Gent de fora: el consell, la gestoria.',
      recipientsPlaceholder: 'correu{\'@\'}exemple.com',
      roles: 'I a qui tingui aquests rols',
      rolesHint: 'Segueix funcionant quan algú marxa.',
      format: 'En quin format',
      saved: 'Programat',
    },

    export: {
      index: 'Índex',
      generated: 'Generat',
    },

    entity: {
      subtitle: 'El que cada mòdul instal·lat sap d\'aquest registre',
      emptyTitle: 'Cap mòdul en sap res',
      emptyHint: 'O no hi ha mòduls instal·lats que ho mesurin, o no tens permís per veure\'ls.',
      failed: 'Aquest mòdul no ha pogut respondre.',
      open: 'Obrir',
      footnote: 'Cada bloc el calcula el seu mòdul, amb els teus permisos. Aquí no es desa cap xifra.',
      kinds: {
        customer: 'Client',
        supplier: 'Proveïdor',
        project: 'Obra',
        user: 'Persona',
        material: 'Material',
        asset: 'Màquina',
        site: 'Centre',
        team: 'Equip',
        vehicle: 'Vehicle',
      },
    },

    dashboard: {
      findings: 'Avisos oberts',
      findingsHelp: 'Quants avisos greus o d\'alerta estan sense marcar com a vistos',
      findingsList: 'Què hauries de saber',
      findingsListHelp: 'Els últims avisos que els mòduls han aixecat sols',
      mine: 'Els meus informes',
      mineHelp: 'Els informes que has desat tu, per ordre d\'última modificació',
    },

    related: {
      figures: 'Xifres',
    },

    notifications: {
      categories: {
        insight: 'Avisos de l\'anàlisi',
      },
      insights: {
        title: 'Hi ha alguna cosa a mirar',
        body: 'L\'anàlisi d\'aquesta nit ha aixecat {count} avisos.',
      },
    },

    analytics: {
      usage: {
        label: 'Informes desats',
        help: 'Una fila per informe desat, amb quantes vegades s\'ha obert',
      },
      dates: {
        created: 'Quan es va desar',
      },
      metrics: {
        count: 'Informes',
        runs: 'Vegades obert',
      },
      dimensions: {
        owner: 'Qui el va desar',
        kind: 'Informe o tauler',
      },
    },
  },

  permissions: {
    reports: {
      read: 'Obrir Informes i fer preguntes. No dóna accés a cap xifra: cada número el calcula '
        + 'el seu mòdul amb els permisos de qui pregunta',
      write: 'Desar informes i taulers propis',
      share: 'Donar un informe a una altra persona. Compartir mai no amplia el que l\'altre pot veure',
      schedule: 'Posar un informe en un rellotge perquè surti per correu sol',
      manage: 'Editar i esborrar informes de qualsevol, i publicar plantilles',
    },
  },

  audit: {
    actions: {
      report: {
        created: 'Informe creat',
        updated: 'Informe modificat',
        deleted: 'Informe esborrat',
        exported: 'Informe exportat',
      },
    },
  },

  settings: {
    ns: {
      reports: {
        // El nombre de la sección en la pantalla de Ajustes.
        title: 'Informes',

        alertThresholdPct: {
          label: 'Avisar quan una xifra es mogui més d\'això',
          help: 'Contra el període anterior. Més baix són més avisos i més soroll; una empresa '
            + 'amb un mes tranquil al 5 % deixa de llegir-los.',
        },
        alertMinImpact: {
          label: 'I només si el canvi val com a mínim això',
          help: 'En euros, per a les xifres que van en euros. Un 40 % sobre 300 € és aritmètica, '
            + 'no una notícia. 0 vol dir que compta qualsevol canvi que passi el percentatge.',
        },
        alertPeriod: {
          label: 'Quin període mira l\'anàlisi de cada nit',
          help: 'I es compara amb l\'immediatament anterior.',
        },
        alertRoles: {
          label: 'A qui s\'avisa quan es troba alguna cosa important',
          help: 'Rols, no persones, perquè segueixi funcionant quan algú marxa. Només el greu i '
            + 'els avisos; la resta espera a la pantalla.',
        },
        aiSummary: {
          label: 'Deixar que l\'assistent escrigui la lectura de les xifres',
          help: 'El bloc de dalt de cada pestanya, i les conclusions d\'un informe exportat. '
            + 'Apagat són els números i els avisos, sense ningú escrivint sobre ells. Consumeix '
            + 'pressupost d\'IA cada vegada que corre.',
        },
        overviewDatasets: {
          label: 'Quants temes cobreix la pestanya de resum',
          help: 'La pestanya de tota l\'empresa pregunta a cada mòdul instal·lat per les seves '
            + 'xifres principals. Amb quinze mòduls això és una pantalla lenta; cada mòdul '
            + 'segueix tenint la seva pestanya.',
        },
        overviewCharts: {
          label: 'Quantes gràfiques dibuixa la pestanya de resum',
          help: 'Les xifres vénen amb la seva pròpia història i dibuixar-la no costa res més. El que '
            + 'sí que costa és la pantalla: passada la mitja dotzena, un resum deixa de ser-ho. '
            + 'Zero deixa les fitxes i les troballes, amb cada gràfica a un clic.',
        },
      },
    },

    mail: {
      reports__scheduled_report: {
        label: 'Informes programats',
        help: 'La bústia des de la qual surt l\'informe que s\'envia sol, amb el seu PDF adjunt.',
      },
    },
  },

  assistant: {
    openers: {
      reports: {
        how_is_it_going: 'Com va l\'empresa aquest mes?',
        what_changed: 'Què ha canviat des del mes passat?',
        worry: 'De què m\'hauria de preocupar?',
      },
    },
  },
}
